// 遥操作协议编解码器
// 使用 protobufjs 的 browser 版本进行编码/解码

import protobuf from 'protobufjs';

// 协议定义（内联，避免外部加载）
const PROTO_DEFINITION = `
syntax = "proto3";
package rotunbot.api;

enum MessageType {
  MESSAGE_TYPE_UNSPECIFIED = 0;
  MESSAGE_TYPE_COMMAND = 1;
  MESSAGE_TYPE_FEEDBACK = 2;
  MESSAGE_TYPE_REQUEST = 3;
  MESSAGE_TYPE_RESPONSE = 4;
  MESSAGE_TYPE_REPORT = 5;
}

message Status {
  enum Code {
    CODE_UNSPECIFIED = 0;
    CODE_OK = 1;
    CODE_INTERNAL_ERROR = 2;
    CODE_INVALID_ARGUMENT = 3;
  }
  Code code = 1;
  string message = 2;
}

message RequestHeader {
  uint32 sequence = 1;
  uint64 request_timestamp_ms = 2;
  string request_id = 3;
}

message ResponseHeader {
  RequestHeader request_header = 1;
  uint64 response_timestamp_ms = 2;
  Status status = 3;
}

message MessageHeader {
  MessageType type = 1;
  string device_id = 2;
  string method = 3;
  string message_id = 4;
  uint64 timestamp_ms = 5;
  string correlation_id = 6;
}

message ReportHeader {
  uint32 sequence = 1;
  uint64 report_timestamp_ms = 2;
  string report_id = 3;
}

message SignedMessage {
  bytes payload = 1;
  bytes signature = 2;
}

message EncryptedMessage {
  bytes iv = 1;
  bytes tag = 2;
  bytes ciphertext = 3;
}

message SignedEncryptedMessage {
  bytes iv = 1;
  bytes tag = 2;
  bytes ciphertext = 3;
}

message Envelope {
  MessageHeader header = 1;
  oneof body {
    bytes raw = 2;
    SignedMessage signed = 3;
    EncryptedMessage encrypted = 4;
    SignedEncryptedMessage signed_encrypted = 5;
  }
}

enum SpeedMode {
  SPEED_MODE_UNSPECIFIED = 0;
  SPEED_MODE_LOW = 1;
  SPEED_MODE_MEDIUM = 2;
  SPEED_MODE_HIGH = 3;
}

message SetTeleopEnabledRequest {
  RequestHeader header = 1;
  bool enabled = 2;
}

message SetTeleopEnabledResponse {
  ResponseHeader header = 1;
  bool current_enabled = 2;
}

message GetTeleopEnabledRequest {
  RequestHeader header = 1;
}

message GetTeleopEnabledResponse {
  ResponseHeader header = 1;
  bool current_enabled = 2;
}

message SetSpeedModeRequest {
  RequestHeader header = 1;
  SpeedMode mode = 2;
}

message SetSpeedModeResponse {
  ResponseHeader header = 1;
  SpeedMode current_mode = 2;
}

message GetSpeedModeRequest {
  RequestHeader header = 1;
}

message GetSpeedModeResponse {
  ResponseHeader header = 1;
  SpeedMode current_mode = 2;
}

message ManualControl {
  RequestHeader header = 1;
  int32 yaw = 2;
  int32 throttle = 3;
  int32 roll = 4;
  int32 pitch = 5;
  uint32 buttons = 6;
}
`;

// 缓存根对象
let root = null;

/**
 * 初始化协议根对象
 * protobufjs 运行时无 loadProto/loadSync（那是 node 的 API），
 * 浏览器内联 .proto 文本应使用 protobuf.parse
 */
export function initProtocol() {
  if (root) return root;

  const parsed = protobuf.parse(PROTO_DEFINITION, { keepCase: true });
  root = parsed.root;
  console.log('[TeleopProtocol] 协议初始化完成');
  return root;
}

/**
 * 获取 Message 类型
 */
export function getMessage(typeName) {
  if (!root) throw new Error('协议未初始化，请先调用 initProtocol()');
  return root.lookupType(`rotunbot.api.${typeName}`);
}

/**
 * 序列化消息为字节
 */
export function encode(typeName, message) {
  const Type = getMessage(typeName);
  const msg = Type.create(message);
  return Type.encode(msg).finish();
}

/**
 * 反序列化字节为消息
 */
export function decode(typeName, bytes) {
  const Type = getMessage(typeName);
  return Type.decode(bytes);
}

/**
 * 编码 ManualControl（joystick 裸帧）
 */
export function encodeManualControl(data) {
  return encode('ManualControl', data);
}

/**
 * 解码 ManualControl
 */
export function decodeManualControl(bytes) {
  return decode('ManualControl', bytes);
}

/**
 * 编码 SetTeleopEnabled 请求
 */
export function encodeSetTeleopEnabled(enabled, header) {
  return encode('SetTeleopEnabledRequest', {
    header: header || createDefaultHeader(),
    enabled
  });
}

/**
 * 编码 SetSpeedMode 请求
 */
export function encodeSetSpeedMode(mode, header) {
  return encode('SetSpeedModeRequest', {
    header: header || createDefaultHeader(),
    mode
  });
}

/**
 * 创建默认 RequestHeader
 */
export function createDefaultHeader() {
  return {
    sequence: 0, // 由调用者递增
    request_timestamp_ms: Date.now(),
    request_id: generateUUID()
  };
}

/**
 * 创建默认 MessageHeader
 */
export function createDefaultMessageHeader(options = {}) {
  return {
    type: 1, // COMMAND
    device_id: options.deviceId || '',
    method: options.method || '',
    message_id: options.messageId || generateUUID(),
    timestamp_ms: Date.now(),
    correlation_id: options.correlationId || ''
  };
}

/**
 * 生成 UUID v4
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default {
  initProtocol,
  getMessage,
  encode,
  decode,
  encodeManualControl,
  decodeManualControl,
  encodeSetTeleopEnabled,
  encodeSetSpeedMode,
  createDefaultHeader,
  createDefaultMessageHeader
};
